
  import { mapState } from 'vuex'
  import moment from 'moment'

  export default {
    data() {
      return {
        isAppCatering: false,
        appCateringRoutes: [ // routes to show the app catering footer on
          '/',
          // '/menu',
          // '/order',
          '/offers',
          '/account',
          '/account/settings',
          '/account/payments',
          '/account/order-history'
        ]
      }
    },
    computed: {
      ...mapState(['location','order','channel','globalClass']),
      mobile() {
        return this.$mq == 'sm' || this.$mq == 'md'
      },
      showMobileNav() {
        return (
          (this.$mq == 'sm' || this.$mq == 'md') &&
          (
            this.$route.name !== 'order-product' &&
            this.$route.name !== 'order-checkout' &&
            this.$route.name !== 'order-items' &&
            this.$route.name !== 'account-login'
          )
        )
      },
      count() {
        if (this.order && this.order.products.length) {
          let count = 0
          this.order.products.forEach(product => {
            count += product.quantity
          })
          return count
        } else {
          return false
        }
      },
      year() {
        return moment().year()
      }
    },
    methods: {
      openUserway() {
        if (window.UserWay) {
          window.UserWay.widgetOpen()
        }
      },
      setPickup() {
        if (this.order && this.order.handoff == 'dispatch') {
          this.$api.setHandoff('pickup')
        } else {
          this.$router.push('/locations?mode=pickup')
        }
      },
      setDelivery() {
        this.$router.push('/locations?mode=delivery')
      }
    },
    watch: {
      '$route.path': {
        immediate: true,
        handler(path) {
          if (process.client) {
            // Show default UserWay button only on /locations page
            if (path === '/locations') {
              document.body.classList.add('show-userway-widget')
            } else {
              document.body.classList.remove('show-userway-widget')
            }
          }
        }
      }
    },
    mounted() {
      if (process.client) {
        // Retrieve source cookie to determine if we're coming from app
        const cookies = document.cookie
          .split('; ')
          .reduce((acc, cookie) => {
            const [key, value] = cookie.split('=')
            acc[key] = value
            return acc
          }, {})
        if (cookies.source && cookies.source == 'app' && this.channel == 'catering') {
          this.isAppCatering = true
          this.$nextTick(() => {
            document.querySelector('footer').style.padding = '20px'
            document.querySelectorAll('footer div > div:not(.mobile-nav):not(.app-catering-footer):not(.handoff-toggle)')
              .forEach(div => {
                if (div.nodeType === Node.ELEMENT_NODE) {
                  div.style.display = 'none'
                }
              })
          })
        }
      }
    },
  }
